import React from 'react'
import Dropdown from 'atoms/Dropdown'
import { Avatar, WalletBalance, Link, BonusBalance } from 'atoms'
import styled from 'styled-components'
import NotificationsBell from 'molecules/NotificationsBell'
import { ProfileConsumer } from 'contexts/profile-context'
import { ConfigConsumer } from 'contexts/config-context'
import PromoNotifications from 'molecules/PromoNotifications'
import UserProfile from './UserProfile'

const Label = styled(Link)`
    display: flex;
    flex-flow: column;
`
const BonusWrapper = styled.div`
  display:flex; 
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(85, 188, 189);
  margin:0 8px;
  box-shadow: 0px 2px 6px #292a2a inset;
  border-radius: 0 0 6px 6px;
`

const BalanceWrapper = styled.div`
    display: flex;
    flex-flow: column;
`

const StyledWalletBalance = styled(WalletBalance)`
  display: flex;
  justify-content: center;
  line-height: 30px;
  background-color: #5A6671;
  border: 2px solid #6D7C8A;
  border-radius: 6px;
  padding: 0px 15px 0px 25px;
  transition: all .25s ease-in;
  font-size: 14px;
  color: #FFF;
`

const StyledAvatar = styled(Avatar)`
  z-index: 1;
  height: 40px;
  width: 40px;
  border: 2px solid #B2BABD;
  margin: -6px -15px 0 0;
  transition: all .25s ease-in;
`

const ProfileWrapper = styled.div`
    padding: 8px 0;
    margin: 8px 0;
    display: inline-flex;
    align-items: end;
    min-width: 80px;
    color: #a2adb8;

    &:hover *,
    &:active * {
      border-color: #D6DEE6;
    }

    * .is-expanded& {
      border-color: #D6DEE6;
    }

    img {
      height: 40px;
      width: 40px;
      border: 2px solid #B2BABD;
      margin-right: -15px;
      margin-top: -6px;
      z-index: 2;
      transition: all .25s ease-in;
    }
`

function LoggedInNav (props) {
  return (
    <React.Fragment>
      <ProfileConsumer>
        {profile => (<React.Fragment>
          <PromoNotifications />
          <ConfigConsumer>
            {config => (
              <NotificationsBell activatedClients={profile.activated_clients} accessToken={config.accessToken} />
            )}
          </ConfigConsumer>
        </React.Fragment>)}
      </ProfileConsumer>

      <ProfileConsumer>
        {profile => (
          <Dropdown
            label={
              <Label href="#">
                <ProfileWrapper>
                  <StyledAvatar picture={profile.picture}/>
                  <BalanceWrapper>
                    <StyledWalletBalance removeBonusTotal={true}/>
                    {
                      profile && profile.bonuses && profile.bonuses.length > 0 &&
                      <BonusWrapper>
                        <BonusBalance bonusArry={profile.bonuses} />
                      </BonusWrapper>
                    }
                  </BalanceWrapper>
                </ProfileWrapper>
              </Label>
            }
          >
            <UserProfile />
          </Dropdown>
        )}
      </ProfileConsumer>

    </React.Fragment>
  )
}

export default LoggedInNav



// WEBPACK FOOTER //
// ./src/molecules/LoggedInNav.js